import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';




export interface IContractorNote extends IModel {
	contractorKey?: string;
	content?: string;
	type?: string;
}

const contractorNoteFactory = modelFactory.createFactory<IContractorNote>('ContractorNote', _.assign({}, model, {
	contractorKey: {
		setFilters: valueFilters.clean
	},
	content: {
		rules: validator.required()
	},
	type: {
	}
}));

export default contractorNoteFactory;